"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Menu = _interopRequireDefault(require("@eig-builder/core-ui/Menu"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    paper: function paper(props) {
      return _objectSpread({
        minWidth: "196px",
        maxWidth: 'auto',
        '& > ul > div:focus': {
          outline: 'none'
        },
        boxShadow: theme.shadows.raisedHighContrast
      }, props.style);
    }
  };
});

var StyledDropdownMenu = function StyledDropdownMenu(_ref) {
  var actionElement = _ref.actionElement,
      children = _ref.children,
      dataElementId = _ref.dataElementId,
      dataElementLabel = _ref.dataElementLabel,
      dataElementLocation = _ref.dataElementLocation,
      anchorOrigin = _ref.anchorOrigin,
      transformOrigin = _ref.transformOrigin,
      defaultWidth = _ref.defaultWidth,
      style = _ref.style;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var classes = useStyles({
    style: style
  });

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  }; // close menu on every click


  return _react.default.createElement("div", (0, _taggingHelper.getDataProperty)({
    dataElementType: _taggingHelper.DataElementTypes.DROPDOWN,
    dataElementLocation: dataElementLocation,
    dataElementLabel: dataElementLabel,
    dataElementId: dataElementId
  }), _react.default.cloneElement(actionElement, {
    onClick: handleClick
  }), _react.default.createElement(_Menu.default, {
    elevation: 1,
    getContentAnchorEl: null,
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: handleClose,
    anchorOrigin: anchorOrigin,
    transformOrigin: transformOrigin,
    defaultWidth: defaultWidth,
    classes: classes
  }, _react.default.Children.map(children, function (child) {
    return _react.default.cloneElement(child, {
      onClick: function onClick() {
        if (child.props.onClick) {
          child.props.onClick();
        }

        handleClose();
      }
    });
  })));
};

StyledDropdownMenu.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object]).isRequired,
  actionElement: _propTypes.default.any.isRequired,
  anchorOrigin: _propTypes.default.object,
  dataElementId: _propTypes.default.string.isRequired,
  dataElementLabel: _propTypes.default.string.isRequired,
  dataElementLocation: _propTypes.default.string.isRequired,
  transformOrigin: _propTypes.default.object,
  defaultWidth: _propTypes.default.string,
  style: _propTypes.default.object
};
StyledDropdownMenu.defaultProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'right'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'right'
  },
  defaultWidth: '196px'
};
var _default = StyledDropdownMenu;
exports.default = _default;